/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { Organization, PrivateUtrValue, User, StakeholderGroup } from "../../lib/wwg.classes"




import { DndListComponent } from "../drag-and-drop/dnd-list.component"
import { StakeholderGroupComponent } from "../stakeholder-group/stakeholder-group.component"

@Component({
  selector: 'wwg-framework-groups-values',
  templateUrl: './framework-group-values.component.html',
  styleUrls: ['./framework-group-values.component.scss']
})
export class FrameworkGroupValuesComponent implements OnInit {

  @ViewChild(DndListComponent, { static: false }) dndList;
  @ViewChild(StakeholderGroupComponent, { static: false }) stakeholderGroup;

  public users: User[];
  public organizations: Organization[] = [];
  public isEdit = false;
  private values: PrivateUtrValue[] = [];

  ngOnInit() {}

  public renderValueName(item: PrivateUtrValue) {
    return item.name || item.note;
  }

  public setValues(values: PrivateUtrValue[]) {
    values.forEach((item) => this.addUTR(item));
  }

  public getValues() {
    return this.values;
  }

  public addUTR(newGroup?: PrivateUtrValue) {
    const utrv = newGroup || new PrivateUtrValue()
    utrv.id = this.createId()
    this.values.push(utrv)
  }

  private createId() {
    return '_' + Math.random().toString(36).substr(2, 9)
  }

  private removePhase(phaseIndex) {
    this.values.splice(phaseIndex, 1);
  }

  public addStakeholderGroup(utr: PrivateUtrValue) {
    if (!utr.stakeholders) {
      utr.stakeholders = new StakeholderGroup();
    }
  }

}
